module.exports = __webpack_public_path__ + "static/media/headshot.48e6bbfe.png";